/**
 * Validate if there are something in attribute
 * @param {String} attr - Attribute
 * @returns {(String|Null)}
 */
export function attr(ref) {
  const attr = this.getAttribute(ref);

  return !attr || !attr.length ? null : attr
}
